import { useGate } from "statsig-react";

export const COVERAGE_BETA_GATE = "fe_enable_coverage_beta";

/**
 * Whether coverage work opens in the Coverage Beta UI.
 *
 * Normally this follows the per-user `fe_enable_coverage_beta` Statsig gate.
 * The training build (`VITE_LABELING_ENVIRONMENT=TRAINING`, the same flag
 * that scopes job listings to training jobs in `utils/auth.ts`) forces it on
 * so every trainee learns the Beta UI regardless of their gate — and skips
 * the gate's loading state, since the answer doesn't depend on it.
 *
 * Staging, PR previews and local dev also build with that flag (the
 * committed `.env` defaults to it), so they get the Beta UI too.
 */
export function useCoverageBetaEnabled() {
  const { value, isLoading } = useGate(COVERAGE_BETA_GATE);
  if (import.meta.env.VITE_LABELING_ENVIRONMENT === "TRAINING") {
    return { enabled: true, isLoading: false };
  }
  return { enabled: value, isLoading };
}
